<app-top-bar (restaurantSelected)="onRestaurantSelected($event)"></app-top-bar>
<app-item-grid [restaurant]="selectedRestaurant"></app-item-grid>
